




















import { Vue, Component } from 'vue-property-decorator';
import { scrollTop } from 'util/assit';

@Component
export default class FloatNav extends Vue {
  // eslint-disable-next-line class-methods-use-this
  clickScrollTop() {
    const currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
    scrollTop(window, currentScroll, 0, 1500);
  }
}
